import React from "react";
import "./LoginHeader.scss";
import useTheme from "../../hooks/useTheme";
import { NewBrandLogo } from "../../assets/images/index";
import { CANVAS_UI_VERSION } from "../../constants/commonConstants";

const LoginHeader = () => {
  const { color, FontFace } = useTheme("LIGHT");

  return (
    <nav
      className="flex flex-middle pl-32 pr-32"
      style={{
        fontSize: FontFace.font_size.small,
        backgroundColor: color.background.primary,
        color: color.background.brand,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
        height: "48px",
        paddingTop: "32px",
      }}
    >

        <NewBrandLogo width="126px" height="39px" />
      <span style={{ marginTop: "12px" }}>({CANVAS_UI_VERSION})</span>
    </nav>
  );
};

export default LoginHeader;
